import React, { FC, useContext } from 'react';
import { Flexbox } from '@bankiru/ui-kit/components/Flexbox';

import { ThemeContext } from '../../../../../context/ThemeContextWrapper';
import { useYandexMetric } from '../../../../../hooks/useYandexMetric';
import { ConsentKeys } from '../../../../../types/consents';
import { SOCIAL_PROVIDERS } from '../../constants';
import { getSocialButton } from '../../helpers';
import { SocialProvider } from '../../types';

type MainSocialProvidersPanelProps = {
	providers: SocialProvider[];
	checkedConsents: Record<ConsentKeys, boolean>;
	isDisabled: boolean;
};

export const MainSocialProvidersPanel: FC<MainSocialProvidersPanelProps> = ({
	providers,
	checkedConsents,
	isDisabled,
}) => {
	const { trackYM } = useYandexMetric();
	const { platform } = useContext(ThemeContext);

	const esiaProvider = providers.find(provider => provider.providerId === SOCIAL_PROVIDERS.esia);
	const otherMainProviders = providers.filter(
		provider => provider.providerId !== SOCIAL_PROVIDERS.esia,
	);

	return (
		<Flexbox flexDirection="column" gap="8">
			{esiaProvider &&
				getSocialButton({
					provider: esiaProvider,
					checkedConsents,
					trackYM,
					isDisabled,
					platform,
					isWithoutLabel: true,
				})}
			<Flexbox gap={8}>
				{otherMainProviders.map(provider =>
					getSocialButton({
						provider,
						checkedConsents,
						trackYM,
						isDisabled,
						platform,
						isWithoutLabel: false,
					}),
				)}
			</Flexbox>
		</Flexbox>
	);
};
